var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-like"},[_c('i',{staticClass:"cmp-icon-like",class:['cmp-icon-like', _vm.isMyLike ? 'active' : ''],on:{"click":function($event){$event.stopPropagation();return _vm.changeLike.apply(null, arguments)}}}),(_vm.showTxt)?_c('span',{staticClass:"ml-10"},[_vm._v(_vm._s(_vm.loveNum)+"人收藏")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }